import React, { useEffect, useState } from 'react';
import {
  IonCheckbox,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonRange,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonToolbar,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { RectToolSettings, Sketch } from '../sketch-tool';

export interface RectToolSettingsProps {
  sketch: Sketch;
}

const SketchToolRectToolSettings = ({ sketch }: RectToolSettingsProps) => {
  const [rectToolSettings, setRectToolSettings] = useState<RectToolSettings>(sketch?.rectToolSettings || {});
  const { t } = useTranslation();

  useEffect(() => {
    if (!sketch) return;
    sketch.rectToolSettings = rectToolSettings;
  }, [sketch, rectToolSettings]);

  const handleModeChange = (event: any) => {
    setRectToolSettings({ ...rectToolSettings, mode: event.target.value });
  };

  const handleColorChange = (event: any) => {
    const color = event.target.value;
    setRectToolSettings({ ...rectToolSettings, strokeStyle: color, fillStyle: color });
  };

  const handleLineWidthChange = (event: any) => {
    setRectToolSettings({ ...rectToolSettings, lineWidth: +event.detail.value });
  };

  const handleShowDimensionsChange = (event: any) => {
    setRectToolSettings({ ...rectToolSettings, showDimensions: event.detail.checked });
  };

  const color = rectToolSettings?.mode === 'stroke' ? rectToolSettings.strokeStyle : rectToolSettings.fillStyle;

  return (
    <IonToolbar color="light">
      <IonGrid>
        <IonRow class="ion-align-items-center ion-nowrap" style={{ overflowX: 'scroll' }}>
          <IonCol size="6">
            <IonItem lines="none" color="light">
              <IonSelect
                aria-label="mode"
                placeholder={t('rectMode')}
                value={rectToolSettings.mode || 'stroke'}
                onIonChange={handleModeChange}
              >
                <IonSelectOption value="fill">
                  {t('fill').toString()}
                </IonSelectOption>
                <IonSelectOption value="stroke">
                  {t('stroke').toString()}
                </IonSelectOption>
              </IonSelect>
            </IonItem>
          </IonCol>
          <IonCol>
            <IonItem lines="none" color="light">
              <IonLabel>
                {t('showDimensions').toString()}
              </IonLabel>
              <IonCheckbox checked={rectToolSettings.showDimensions || false} onIonChange={handleShowDimensionsChange} />
            </IonItem>
          </IonCol>
          <IonCol size="14">
            <IonItem lines="none" color="light">
              <IonLabel>
                {t('lineWidth').toString()}
              </IonLabel>
              <IonRange value={rectToolSettings.lineWidth || 1} min={1} max={30} onIonChange={handleLineWidthChange} />
            </IonItem>
          </IonCol>
          <IonCol>
            <input type="color" value={color || '#000000'} onChange={handleColorChange} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonToolbar>
  );
};

export default SketchToolRectToolSettings;
